import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  fetchFinancialsGiq,
  fetchFinancialsByCompanyNameGiq,
} from "../../../services/accIqService";
import {
  FETCH_SELF_FINANCIALS_GIQ_REQUEST,
  fetchSelfFinancialsGiqFailure,
  fetchSelfFinancialsGiqSuccess,
} from "../actions/selfFinancialsGiqActions";

// Worker Saga
function* fetchSelfFinancialsGiqSaga() {
  try {
    const payload = yield select(
      (state) => state?.selfFinancialsGiqReducer?.payload
    );

    const data = yield call(fetchFinancialsGiq, payload?.identifier);
    // const data = yield call(
    //   fetchFinancialsByCompanyNameGiq,
    //   payload?.competitor
    // );
    yield put(fetchSelfFinancialsGiqSuccess(data));
  } catch (error) {
    yield put(fetchSelfFinancialsGiqFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchSelfFinancialsGiq() {
  yield takeLatest(
    FETCH_SELF_FINANCIALS_GIQ_REQUEST,
    fetchSelfFinancialsGiqSaga
  );
}
